<template>
  <!-- <v-navigation-drawer
    id="core-navigation-drawer"
    ref="drawer"
    v-model="drawer"
    :dark="barColor !== 'rgba(228, 226, 226, 1), rgba(255, 255, 255, 0.7)'"
    :gradient="`to bottom, ${barColor}`"
    :expand-on-hover="expandOnHover"
    :right="$vuetify.rtl"
    :src="barImage"
    mobile-breakpoint="960"
    app
    width="300"
    v-bind="$attrs"
  > -->
  <v-navigation-drawer
    id="core-navigation-drawer"
    ref="drawer"
    v-model="drawer"
    :expand-on-hover="expandOnHover"
    :right="$vuetify.rtl"
    app
    v-bind="$attrs"
  >
    <!-- <template v-slot:img="props">
      <v-img
        :gradient="`to bottom, ${barColor}`"
        v-bind="props"
      />
    </template> -->
    <v-row no-gutters justify="center" align="center"  >
      <v-container fluid max-height="100%">
        <v-row justify="center">
          <v-col cols="12" sm="8" md="6" lg="10" xl="10">
        <v-img
        max-height="100%"
        max-weight="100%"
            src="../../../../assets/logo.png" 
        ></v-img>
      </v-col>
        </v-row>
      </v-container>
    
    </v-row>

    <v-divider class="mb-1" />
    <v-treeview :items="items"
      :open="initiallyOpen"
      activatable
      open-on-click
      item-key="current_skey">
      <template v-slot:prepend="{ item, open }">
        <v-icon color="black lighten-3" v-if="item.node_type.trim()==='W'">
          {{ open ? 'mdi-folder-open-outline' : 'mdi-folder-outline' }}
        </v-icon>
        <v-icon v-else color="black lighten-1">
          {{ item.small_bitmap && item.small_bitmap.trim() !== '' ? item.small_bitmap : 'mdi-file-outline' }}
        </v-icon>
      </template>
      <template v-slot:label="{ item }">
        <v-list-item class="pa-0" :to="item.link">{{ item.name }}</v-list-item>
      </template>
    </v-treeview>
    <template v-slot:append>
      <v-divider />
      <v-list nav dense>
        <v-list-item
          to="/about" 
          link
          color="primary"
        >
          <v-list-item-icon>
            <v-icon>mdi-information-outline</v-icon> </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Intelligent Health OS</v-list-item-title>
            <v-list-item-subtitle>Version 1.0.0</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </template>
  </v-navigation-drawer>
</template>

<script>
  // Utilities
  import {
    mapState,
  } from 'vuex'
  import axios from 'axios'

  export default {
    name: 'DashboardCoreDrawer',

    props: {
      parentComponent: null,
      expandOnHover: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      navigation: {
        shown: false,
        width: 300,
        borderSize: 3
      },
      initiallyOpen: ['public'],
      fixed: false,
      menu: [],
      items: [
        // {
        //   action: 'mdi-ticket',
        //   items: [{ title: 'List Item' }],
        //   title: 'Attractions',
        // },
        // {
        //   action: 'mdi-silverware-fork-knife',
        //   active: true,
        //   items: [
        //     { title: 'Breakfast & brunch' },
        //     { title: 'New American' },
        //     { title: 'Sushi' },
        //   ],
        //   title: 'Dining',
        // },
        // {
        //   action: 'mdi-school',
        //   items: [{ title: 'List Item' }],
        //   title: 'Education',
        // },
        // {
        //   action: 'mdi-run',
        //   items: [{ title: 'List Item' }],
        //   title: 'Family',
        // },
        // {
        //   action: 'mdi-bottle-tonic-plus',
        //   items: [{ title: 'List Item' }],
        //   title: 'Health',
        // },
        // {
        //   action: 'mdi-content-cut',
        //   items: [{ title: 'List Item' }],
        //   title: 'Office',
        // },
        // {
        //   action: 'mdi-tag',
        //   items: [{ title: 'List Item' }],
        //   title: 'Promotions',
        // },
      ],
    }),

    computed: {
      ...mapState(['barColor', 'barImage']),
      drawer: {
        get () {
          return this.$store.state.drawer
        },
        set (val) {
          this.$store.commit('SET_DRAWER', val)
        },
      },
      drawerWidth: {
        get () {
          return this.$store.state.drawerWidth
        },
        set (val) {
          this.$store.commit('SET_DRAWER_WIDTH', val)
        },
      },
      computedItems () {
        return this.items.map(this.mapItem)
      },
      profile () {
        return {
          avatar: true,
          title: this.$t('avatar'),
        }
      },
    },

    created () {
      this.getMenu(this.$i18n.locale)
    },

    mounted () {
      this.setBorderWidth()
      this.setEvents()
    },
  
    methods: {
      mapItem (item) {
        return {
          ...item,
          children: item.children ? item.children.map(this.mapItem) : undefined,
          title: this.$t(item.title),
        }
      },
      recurMenu: function (level) {
        if (this.menu.filter(x => x.node_level === level).length === 0) {
        } else {
          // console.log(this.menu.filter(x => x.node_level === level))
          var menuLevel = this.menu.filter(x => x.node_level === level)
          for (var i = 0; i < menuLevel.length; i++) {
            if (menuLevel[i]['node_type'].trim() === 'W') {
              var subitem = []
              for (var j = 0; j < this.menu.length; j++) {
                if (this.menu[j]['from_current_skey'] === menuLevel[i]['current_skey']) {
                  if (this.menu[j]['node_type'].trim() === 'W') {
                    this.recurMenu(level + 2)
                  }
                  subitem.push({title: this.menu[j]['node_name'], link: '/' + this.menu[j]['win_name']})
                }
              }
              this.items.push({action: 'folder_open', title: menuLevel[i]['node_name'], link: '/', items: subitem})
            } else {
              this.items.push({title: menuLevel[i]['node_name'], link: '/' + menuLevel[i]['win_name']})
            }
          }
        }
      },
      recurseMenu: function (parent, level) {
        this.htmlStrTxt = '<ul>'
        for (var x in this.menu) {
          if (this.menu[x]['from_current_skey'] === parent) {
            this.htmlStrTxt += '<li><span class="level-' + level + '">' + this.menu[x]['node_name'] + '</span>'
            var currentSkey = this.menu[x]['current_skey']
            if (this.menu.filter(x => x.from_current_skey === currentSkey).length > 0) {
              this.htmlStrTxt += this.recurseMenu(currentSkey, level + 1)
            }
            this.htmlStrTxt += '</li>'
          }
        }
        return this.htmlStrTxt + '</ul>'
      },
      getNestedChildren: function (arr, parent) {
        var out = []
        for (var i in arr) {
          if (arr[i].from_current_skey === parent) {
            var children = this.getNestedChildren(arr, arr[i].current_skey)
            if (children.length) {
              arr[i].children = children
              arr[i].action = 'folder_open'
            }
            arr[i].name = arr[i]['node_name']
            arr[i].title = arr[i]['node_name']
            arr[i].link = arr[i]['win_name']
            out.push(arr[i])
            var component = this.$router.options.routes[2].children.find(function (x) {
              return (x.name === arr[i]['win_name'])
            })
            if (component !== undefined && component !== null) {
              component.title = arr[i]['node_name']
            }
          }
        }
        return out
      },
      getMenu: function (languageID) {
        const apiBase = process.env.VUE_APP_API
        const apiVersion = process.env.VUE_APP_API_VERSION
        const apiModule = 'nav'
        const endpoint = apiBase + '/api/' + apiVersion + '/' + apiModule + '/getMenu'
        const apiName = process.env.VUE_APP_NAME
        axios.post(endpoint, {
          data: {user_id: 'kritsada', app_name: apiName, sort_type: 'name', from_node: 0, 'language_id': languageID}
        })
        /* axios({url: process.env.VUE_APP_API + '/getMenu' + process.env.VUE_APP_DATABASE_TYPE, data: {user_id: 'kritsada', app_name: 'clinic', sort_type: 'name', from_node: 0, 'language_id': languageID}, method: 'POST'}) */
        .then(resp => {
          if (resp.data.isSuccess) {
            this.items = []
            // this.items.push({currentSkey: 0, action: 'home', title: 'Home', link: '/'})

            this.items = this.getNestedChildren(resp.data.data, 0)
            // this.parentComponent.appBar.setWindowTitle(this.parentComponent.appBar.getWindowTitle(this.$route.name))

            // for (var i = 0; i < resp.data.data.length; i++) {
            //   if (resp.data.data[i]['node_level'] !== 2) {
            //     continue
            //   }
            //   if (resp.data.data[i]['node_type'].trim() === 'W') {
            //     var subitem = []
            //     for (var j = 0; j < resp.data.data.length; j++) {
            //       if (resp.data.data[j]['from_current_skey'] === resp.data.data[i]['current_skey']) {
            //         subitem.push({title: resp.data.data[j]['node_name'], link: '/' + resp.data.data[j]['win_name']})
            //       }
            //     }
            //     this.items.push({action: 'folder_open', title: resp.data.data[i]['node_name'], link: '/', items: subitem})
            //   } else {
            //     this.items.push({title: resp.data.data[i]['node_name'], link: '/' + resp.data.data[i]['win_name']})
            //   }
            // }
          } else {
            this.$swal({type: 'error', title: resp.data.reasonText})
          }
        })
        .catch(e => {
          this.$swal({type: 'error', title: e.message})
        })
      },
      setBorderWidth () {
        let i = this.$refs.drawer.$el.querySelector(
          '.v-navigation-drawer__border'
        )
        i.style.width = this.navigation.borderSize + 'px'
        i.style.cursor = 'ew-resize'
      },

      setEvents () {
        const minSize = this.navigation.borderSize
        const el = this.$refs.drawer.$el
        const drawerBorder = el.querySelector('.v-navigation-drawer__border')
        const vm = this
        const direction = el.classList.contains('v-navigation-drawer--right')
          ? 'right'
          : 'left'

        function resize (e) {
          document.body.style.cursor = 'ew-resize'
          let f = direction === 'right'
            ? document.body.scrollWidth - e.clientX
            : e.clientX
          el.style.width = f + 'px'
        }

        drawerBorder.addEventListener(
          'mousedown',
          function (e) {
            if (e.offsetX < minSize) {
              el.style.transition = 'initial'; document.addEventListener('mousemove', resize, false)
            }
          },
          false
        )

        document.addEventListener(
          'mouseup',
          function () {
            el.style.transition = ''
            // vm.navigation.width = el.style.width
            vm.drawerWidth = el.style.width
            document.body.style.cursor = ''
            document.removeEventListener('mousemove', resize, false)
          },
          false
        )
      }
    },
  }
</script>

<style lang="sass">
  @import '~vuetify/src/styles/tools/_rtl.sass'

  #core-navigation-drawer
    .v-list-group__header.v-list-item--active:before
      opacity: .24

    .v-list-item
      &__icon--text,
      &__icon:first-child
        justify-content: center
        text-align: center
        width: 20px

        +ltr()
          margin-right: 24px
          margin-left: 12px !important

        +rtl()
          margin-left: 24px
          margin-right: 12px !important

    .v-list--dense
      .v-list-item
        &__icon--text,
        &__icon:first-child
          margin-top: 10px

    .v-list-group--sub-group
      .v-list-item
        +ltr()
          padding-left: 8px

        +rtl()
          padding-right: 8px

      .v-list-group__header
        +ltr()
          padding-right: 0

        +rtl()
          padding-right: 0

        .v-list-item__icon--text
          margin-top: 19px
          order: 0

        .v-list-group__header__prepend-icon
          order: 2

          +ltr()
            margin-right: 8px

          +rtl()
            margin-left: 8px
</style>
<style>
/* width */
.v-navigation-drawer__content::-webkit-scrollbar {
  width: 10px;
}

/* Track */
.v-navigation-drawer__content::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey; 
  border-radius: 10px;
}
 
/* Handle */
.v-navigation-drawer__content::-webkit-scrollbar-thumb {
  background: powderblue; 
  border-radius: 10px;
}

/* Handle on hover */
.v-navigation-drawer__content::-webkit-scrollbar-thumb:hover {
  background: #2672B9; 
}
</style>